function NotFound() {
    return <h1 style={{ marginTop: '20px' }}>404 Page Not Found</h1>;
}

export default NotFound;
